module.exports = __webpack_public_path__ + "images/factuals-icon-black@2x_95f15840f04a2f87029c7f0b17c50125.png";